import { render, staticRenderFns } from "./LayoutWorkspaceToggler.vue?vue&type=template&id=acce161c&scoped=true&lang=pug"
import script from "./LayoutWorkspaceToggler.vue?vue&type=script&lang=js"
export * from "./LayoutWorkspaceToggler.vue?vue&type=script&lang=js"
import style0 from "./LayoutWorkspaceToggler.vue?vue&type=style&index=0&id=acce161c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acce161c",
  null
  
)

export default component.exports